import styled, { css } from "styled-components";

const StylesStatic = css`
  margin-top: 8rem;
`;

const StylesFixed = css`
  display: none;
  position: absolute;
`;

const Menu = styled.nav`
  width: 100%;
  ${({ fixed }) => (fixed ? StylesFixed : StylesStatic)};
`;

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js